<template>
  <div>
    <div class="container p-5">
      <div v-if="book" class="row g-5">
        <!-- Left Column -->
        <div class="col-12 col-sm-5 col-lg-3">
          <div class="book-image-container">
            <img
              :src="
                selectedCover ?
                `${BASE_IMAGE_PREFIX}/${selectedCover}` :
                'https://libreture.com/static/images/book-placeholder.png'
              "
              alt="Book Cover"
              class="img-fluid book-image"
            />
          </div>
          <div class="d-flex gap-2">
            <img
              v-for="(image, index) in book.images"
              :key="`mini-${index}`"
              :src="
                image ?
                `${BASE_IMAGE_PREFIX}/${image}` :
                'https://libreture.com/static/images/book-placeholder.png'
              "
              alt="Book Cover"
              class="img-fluid mini-view"
              @click="selectedCover = image"
            />
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-sm-7 col-lg-9">
          <!-- Stock Status -->
          <div class="stock-status mb-2">
            <span v-if="book.stock > 0" class="status-badge me-2 mb-2 mb-md-0">In Stock</span>
            <!-- <span v-if="book.productCategory === 'book'" class="status-badge">Premium Paper Print</span> -->
            <span v-if="book.productCategory === 'stationary'" class="status-badge">Quality Stationary Item</span>
          </div>

          <!-- Title -->
          <h1 class="book-title">{{ book.title }}</h1>

          <!-- Meta Information -->
          <div
            v-if="book.productCategory !== 'stationary'"
            class="book-meta"
          >
            <span class="meta-label">Author:</span>
            <router-link
              :to="'/search/?a=' + book.author.replace(/ /g, '_')"
              style="text-decoration: none"
            >
              <span class="meta-value">
                {{ book.author }}
              </span>
            </router-link>
          </div>

          <!-- Price -->
          <!-- <div class="price-container">
            <span v-if="selectedCoverType !== 'regular-paperback'">
              <span v-if="book.isOnSale && book.salePrice" class="price">
                <span class="text-decoration-line-through text-muted">
                  ৳ {{ book.price }}
                </span>
                <span> ৳ {{ book.salePrice + hardCoverPrice }}</span>
              </span>
              <span v-else class="price">
                ৳ {{ book.price + hardCoverPrice }}
              </span>
            </span>
            <span v-else class="price">
              ৳ {{ book.regularPrintPrice }}
            </span>
          </div> -->
          <div class="price-container" v-if="selectedVariant">
            <span class="price">
              <span v-if="selectedVariant.salePrice">
                <span class="text-decoration-line-through text-muted">
                  ৳ {{ selectedVariant.price }}
                </span>
                <span> ৳ {{ selectedVariant.salePrice }}</span>
              </span>
              <span v-else>
                ৳ {{ selectedVariant.price }}
              </span>
            </span>
          </div>

          <!-- <div class="d-flex gap-2 my-3">
            <button
              v-if="book.coverOptions.includes('paperback')"
              class="btn custom-btn"
              :class="selectedVariant === 'paperback' ? null : 'outline'"
              @click="selectedVariant = 'paperback'"
            >
              Paperback
            </button>
            <button
              v-if="book.coverOptions.includes('hardcover')"
              class="btn custom-btn"
              :class="selectedVariant === 'hardcover' ? null : 'outline'"
              @click="selectedVariant = 'hardcover'"
            >
              Hardcover
            </button>
          </div> -->
          <div
            v-if="book.productCategory !== 'stationary'"
            class="d-flex gap-2 my-3"
          >
            <button
              v-if="paperbackVariants.length"
              class="btn custom-btn"
              :class="selectedVariant?.meta.coverType === 'paperback' ? null : 'outline'"
              @click="selectCover('paperback')"
            >
              Paperback
            </button>

            <button
              v-if="hardcoverVariants.length"
              class="btn custom-btn"
              :class="selectedVariant?.meta.coverType === 'hardcover' ? null : 'outline'"
              @click="selectCover('hardcover')"
            >
              Hardcover
            </button>
          </div>
          <!-- <div class="d-flex gap-2">
            <button
              v-if="book.regularPrintAvailability && selectedVariant === 'paperback'"
              class="btn custom-btn"
              :class="selectedCoverType === 'regular-paperback' ? null : 'outline'"
              @click="selectedCoverType = 'regular-paperback'; isHardCover = false"
            >
              Regular
            </button>
            <button
              v-if="book.coverOptions.includes('paperback') && selectedVariant === 'paperback'"
              class="btn custom-btn"
              :class="selectedCoverType === 'paperback' ? null : 'outline'"
              @click="selectedCoverType = 'paperback'; isHardCover = false"
            >
              Premium
            </button>
            <button
              v-if="book.coverOptions.includes('hardcover') && selectedVariant === 'hardcover'"
              class="btn custom-btn"
              :class="selectedCoverType === 'hardcover' ? null : 'outline'"
              @click="selectedCoverType = 'hardcover'; isHardCover = true"
            >
              Premium
            </button>
          </div> -->
          <div
            v-if="book.productCategory !== 'stationary'"
            class="d-flex gap-2"
          >
            <button
              v-for="variant in filteredPrintVariants"
              :key="variant._id"
              class="btn custom-btn"
              :class="selectedVariant.meta.printType === variant.meta.printType ? null : 'outline'"
              @click="selectedVariant = variant"
            >
              {{ variant.meta.printType === 'regular' ? 'Regular' : 'Premium' }}
            </button>
          </div>
          <div class="counter-wrapper">
            <button
              class="btn-counter"
              @click="quantity--"
              :disabled="quantity <= 1"
            >
              -
            </button>
            <span class="">{{ quantity }}</span>
            <button class="btn-counter" @click="quantity++">+</button>
          </div>

          <!-- <div class="form-check form-switch mb-3 mt-3">
            <input
              v-model="isHardCover"
              class="form-check-input custom-switch"
              type="checkbox"
              role="switch"
              id="checkDefault"
            />
            <label class="form-check-label" for="checkDefault">
              Get Hardcover <small class="silent-info">(60 BDT Extra)</small>
            </label>
          </div> -->
          <!-- Action Buttons -->
          <div class="action-buttons">
            <button class="btn btn-add-cart" @click="addToCart(book)">
              <i class="bi bi-cart3"></i>
              Add to cart
            </button>
            <button class="btn btn-add-cart" @click="buyNow(book)">
              Buy now
            </button>
            <button class="btn btn-wishlist" @click="addToWishlist(book)">
              <i class="bi bi-heart"></i>
              Add to wishlist
            </button>
          </div>

          <!-- Description -->
          <div class="description">
            <p>{{ book.description }}</p>
          </div>

          <!-- Categories -->
          <div class="categories-section">
            <div class="category-row">
              <span class="meta-label">Categories:</span>
              <div
                class="category-link"
                v-for="(category, index) in book.category"
                :key="`category-${index}`"
              >
                <router-link
                  :to="'/search/?c=' + category.toLowerCase().replace(/ /g, '_')"
                  style="text-decoration: none"
                >
                  <span class="category-text">
                    {{ category.replace(/_/g, ' ') }}
                  </span>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Social Share -->
          <div class="social-share">
            <a
              href="https://www.facebook.com/nilkhet.com.bd/"
              target="_blank"
              class="social-icon custom"
            >
              <i class="bi bi-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/nilkhetbd"
              target="_blank"
              class="social-icon custom"
            >
              <i class="bi bi-instagram"></i>
            </a>
            <a
              href="https://wa.me/8801711086468"
              target="_blank"
              class="social-icon custom"
            >
              <i class="bi bi-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Recent Posts Section -->
    <div class="recent-posts mt-5 container-fluid container-sm">
      <h3>More Books</h3>
      <hr />
      <div>
        <!-- Book Section -->
        <div v-if="recentBooks.length" class="book-section">
          <div class="row g-4">
            <!-- Book Card -->
            <div
              v-for="(book, i) in recentBooks"
              :key="`book-${i}`"
              class="col-6 col-sm-4 col-lg-2"
            >
              <div class="book-card">
                <img
                  role="button"
                  @click="fetchBookDetails(book._id)"
                  :src="
                    book.images.length ?
                    `${BASE_IMAGE_PREFIX}/${book.images?.[0]}` :
                    'https://libreture.com/static/images/book-placeholder.png'
                  "
                  alt="Book Cover"
                  class="book-image"
                  draggable="false"
                />
                <h5
                  role="button"
                  @click="fetchBookDetails(book._id)"
                  class="book-title-mini"
                >
                  {{ book.title }}
                </h5>
                <div
                  v-if="book.productCategory !== 'stationary'"
                  class="book-author"
                >
                  {{ book.author }}
                </div>
                <div class="book-price" v-if="selectedVariant">
                  <span v-if="selectedVariant.salePrice">
                    <span class="text-muted text-decoration-line-through">
                      ৳ {{ selectedVariant.price }}
                    </span>
                    ৳ {{ selectedVariant.salePrice }}
                  </span>
                  <span v-else>
                    ৳ {{ selectedVariant.price }}
                  </span>
                </div>
                <div
                  class="card-footer p-0 pb-4 pt-0 border-top-0 bg-transparent"
                >
                  <div class="text-center">
                    <span
                      class="btn btn-outline-dark btn-sm mt-auto me-1 text-uppercase"
                      style="font-size: 10px"
                      @click="addToCart(book)"
                    >
                      <i class="bi bi-cart3"></i> Add to cart
                    </span>
                    <span
                      class="btn btn-outline-dark btn-sm mt-auto text-uppercase"
                      style="font-size: 10px"
                      @click="addToWishlist(book)"
                    >
                      <i class="bi bi-suit-heart"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-5">
          <p>No books available.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  BASE_URL,
  BASE_IMAGE_PREFIX
} from "@/globals";
import { usePageMeta } from '@/composables/usePageMeta';
import { analytics } from '@/services/analytics';

export default {
  name: "SingleBook",
  data() {
    return {
      BASE_IMAGE_PREFIX,
      book: null,
      quantity: 1,
      recentBooks: [],
      selectedCover: "",
      // isHardCover: false,
      // selectedCoverType: "paperback",
      selectedVariant: null
    };
  },
  mounted() {
    this.fetchBookDetails();
    this.fetchRecentBooks();
  },
  computed: {
    paperbackVariants() {
      return this.book?.variants?.filter(
        v => v.meta.coverType === "paperback"
      ) || [];
    },
    hardcoverVariants() {
      return this.book?.variants?.filter(
        v => v.meta.coverType === "hardcover"
      ) || [];
    },
    filteredPrintVariants() {
      if (!this.selectedVariant) return [];
      return this.book.variants.filter(
        v => v.meta.coverType === this.selectedVariant.meta.coverType
      );
    },
    hardCoverPrice() {
      return this.isHardCover ? this.book?.hardcoverExtraCharge : 0;
    },
    pageMeta() {
      if (!this.book) {
        return {
          title: "Nilkhet Books",
          description: "Place for quality books and stationery items",
          image: "",
        };
      }

      const imagePath = this.book.images?.[0];
      const image = imagePath ? `${BASE_IMAGE_PREFIX}/${imagePath}` : "";
      const description =
        (this.book.description || "")
          .replace(/<[^>]*>/g, "")
          .trim()
          .slice(0, 500) || "Place for quality books and stationery items";
      const url =
        typeof window !== "undefined"
          ? `${window.location.origin}/book/${this.book._id}/${this.slugify(this.book.title)}`
          : "";

      return {
        title: this.book.title,
        description,
        image,
        url,
        product: true,
      };
    },
  },
  methods: {
    async fetchBookDetails(id) {
      const bookId = id || this.$route.params.id;
      const slug = this.$route.params.slug;
      try {
        const response = await axios.get(`${BASE_URL}/api/products/${bookId}`);
        this.book = response.data;
        // default to first variant
        if (this.book.variants?.length) {
          this.selectedVariant = this.book.variants[0];
        }
        usePageMeta(this.pageMeta);
        const correctSlug = this.slugify(this.book.title);
        if (!slug || slug !== correctSlug) {
          this.$router.replace({
            name: 'ProductDetails',
            params: { id: bookId, slug: correctSlug }
          });
        }
        this.selectedCover = this.book.images.length ? this.book.images[0] : "";
        this.scrollToTop();
        analytics.viewContent(this.book, this.selectedVariant.price)
      } catch (error) {
        console.error("Error fetching book details:", error);
      }
    },
    async fetchRecentBooks() {
      try {
        const response = await axios.get(`${BASE_URL}/api/products?limit=6`);
        this.recentBooks = response.data.books;
      } catch (error) {
        console.error("Error fetching book details:", error);
      }
    },
    selectCover(type) {
      const variants = this.book.variants.filter(
        v => v.meta.coverType === type
      );

      if (variants.length) {
        this.selectedVariant = variants[0];
      }
    },
    slugify(text) {
      return text
        .toString()                  // convert to string
        .normalize("NFD")            // normalize accents (café → cafe)
        .replace(/[\u0300-\u036f]/g, "") // remove diacritics
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "") // remove invalid chars
        .replace(/\s+/g, "-")         // collapse whitespace and replace by -
        .replace(/-+/g, "-");         // collapse dashes
    },
    addToCart(book) {
      const cartItem = {
        product: book,
        quantity: this.quantity,
        variant: this.selectedVariant
      };

      this.$store.dispatch("addToCart", cartItem);

      this.$root.showToast({
        message: "Item added to cart",
        status: "success",
        duration: 3000,
      });
      analytics.addToCart(book,
        this.selectedVariant.salePrice || this.selectedVariant.price,
        this.quantity)
    },
    addToWishlist(book) {
      const wishedItem = {
        ...book,
        quantity: this.quantity,
        variant: this.selectedVariant
      };
      this.$store.dispatch("addToWishlist", wishedItem);
      this.$root.showToast({
        message: "Item added to wishlist",
        status: "success",
        duration: 3000,
      });
      analytics.addToWishlist(book,
        this.selectedVariant.salePrice || this.selectedVariant.price,
        this.quantity)
    },
    buyNow(book) {
      const cartItem = {
        product: book,
        quantity: this.quantity,
        variant: this.selectedVariant
      };
      this.$store.dispatch("addToCart", cartItem);
      this.$router.push("/checkout");
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stock-status {
  .status-badge {
    display: inline-block;
    padding: 6px 12px;
    background-color: #ecf7ed;
    color: #198754;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
  }
}

.book-title {
  font-size: 42px;
  font-weight: 700;
  color: #111827;
  margin: 10px 0;
}

.book-meta {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 10px;

  .meta-label {
    color: #6b7280;
    font-size: 15px;
  }

  .meta-value {
    color: #111827;
    font-weight: 500;
  }

  .rating-container {
    display: flex;
    align-items: center;
    gap: 8px;

    .stars {
      color: #ffa41c;
      font-size: 14px;
    }

    .rating-number {
      color: #6b7280;
      font-size: 14px;
    }
  }

  .sku-container {
    font-size: 14px;
  }
}

.price-container {
  // margin: 32px 0;

  .price {
    font-size: 36px;
    font-weight: 600;
    color: #e11d48;
  }
}

.description {
  color: #6b7280;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 32px;
  white-space: pre-line;
}

.custom-switch {
  cursor: pointer;
}
.custom-switch:checked {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}
.custom-switch:focus {
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.silent-info {
  font-size: 10px;
  color: var(--text-gray);
}

.action-buttons {
  display: flex;
  gap: 15px;
  margin-bottom: 40px;

  .btn {
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 6px;

    i {
      font-size: 20px;
    }
  }

  .btn-add-cart {
    background-color: #e11d48;
    color: white;
    border: none;

    &:hover {
      background-color: #c5392c;
    }
  }

  .btn-wishlist {
    border: 1px solid #d1d5db;
    background-color: white;
    color: #111827;

    &:hover {
      background-color: #f3f4f6;
    }
  }
}

.categories-section {
  margin-bottom: 32px;

  .category-row,
  .tags-row {
    margin-bottom: 12px;
    font-size: 15px;

    .meta-label {
      color: #6b7280;
      margin-right: 8px;
    }

    a {
      color: #111827;
      text-decoration: none;

      &:hover {
        color: #e11d48;
      }
    }
  }
}

.social-share {
  display: flex;
  gap: 12px;

  .social-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-decoration: none;
    transition: transform 0.2s;

    &:hover {
      transform: translateY(-2px);
    }

    &.facebook {
      background-color: #1877f2;
    }
    &.twitter {
      background-color: #1da1f2;
    }
    &.linkedin {
      background-color: #0a66c2;
    }
    &.pinterest {
      background-color: #e60023;
    }
    &.custom {
      background-color: var(--primary-color);
    }

    i {
      font-size: 18px;
    }
  }
}

.navigation-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;

  .nav-link {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #6b7280;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;

    &:hover {
      color: #e11d48;
    }
  }
}

.book-image-container {
  border-radius: 8px;
  overflow: hidden;
  // box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
  //   0 2px 4px -1px rgba(0, 0, 0, 0.06);

  .book-image {
    width: 100%;
    height: auto;
    object-fit: cover;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
}
.mini-view {
  width: 40px;
  height: auto;
  cursor: pointer;
  border-radius: 5px;
  &.active {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
}

// Responsive adjustments
@media (max-width: 991.98px) {
  .book-title {
    font-size: 32px;
  }

  .book-meta {
    flex-wrap: wrap;
    gap: 16px;
  }

  .action-buttons {
    flex-direction: column;

    .btn {
      width: 100%;
    }
  }
}

/* Book Grid */
.book-tabs {
  border-bottom: none;
  margin-bottom: 30px;
}

.book-tabs .nav-link {
  color: var(--text-gray);
  border: none;
  padding: 10px 20px;
  font-weight: 500;
}

.book-tabs .nav-link.active {
  color: var(--primary-color);
  background: none;
  position: relative;
}

.book-tabs .nav-link.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 2px;
  background-color: var(--primary-color);
}

.book-card {
  background: white;
  border-radius: 8px;
  padding: 0 20px 0 0;
  text-align: center;
  transition: transform 0.3s;
  position: relative;
  /* box-shadow: 0 2px 10px rgba(0,0,0,0.05); */
}

.book-card::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #ccc;
  opacity: 0.3;
}

.book-card:hover {
  transform: translateY(-5px);
}

.book-image {
  width: 100%;
  height: auto;
  border-radius: 15px;
  margin-bottom: 15px;
  cursor: pointer;
}

.book-title-mini {
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.book-author {
  color: var(--text-gray);
  font-size: 14px;
  margin-bottom: 8px;
}

.book-rating {
  color: #ffc107;
  margin-bottom: 8px;
}

.book-price {
  color: var(--primary-color);
  font-weight: 700;
  font-size: 18px;
}

.custom-btn {
  background: var(--primary-color);
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  padding: 5px 15px;
  border-radius: 30px;
  &.outline {
    background: #fff;
    border: 1px solid var(--primary-color);
    color: var(--text-gray);
  }
}

.counter-wrapper {
  max-width: 150px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
  margin: 20px 0;
  padding: 10px;
  border: 1px solid var(--primary-color);
  border-radius: 50px;
  .btn-counter {
    font-size: 20px;
    line-height: 24px;
    background: transparent;
    border: none;
  }
}
</style>
